export default __webpack_public_path__ + "static/media/cabourg15.94816c74.jpg";